module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "piligrim"
    }
  }, [_c('v-app', [_c('v-container', {
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xl12": ""
    }
  }, [_c('v-card-text', {
    staticClass: "px-0"
  }, [_c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgba(0,0,0,1)",
      "font-weight": "bold"
    }
  }, [_vm._v(" Reservations ")])])]), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-content', {
    attrs: {
      "ripple": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Pilgrim Season")]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "grey lighten-3",
    staticStyle: {
      "max-height": "300px",
      "overflow-y": "auto"
    }
  }, [_c('p', [_vm._v("1) The schedule of the opening and closing of the accommodation facilities Hostel D and Meher Pilgrim Retreat (MPR) at Meherabad is as follows:")]), _vm._v(" "), _c('ol', [_c('p', [_vm._v("a) Hostel D is open for pilgrims from 1 May. It remains closed for the summer from 15 March to 30 April.")])]), _vm._v(" "), _c('ol', [_c('p', [_vm._v("b) Meher Pilgrim Retreat (MPR) is open to pilgrims from 15 June. It remains closed for the summer from 1 May to 14 June.")])]), _vm._v(" "), _c('p', [_vm._v("2) Meherazad will be open for pilgrims till 14 March and will be closed from 15 March till 30 June. Meherazad will reopen for the following pilgrim season from 01 July.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Meher Baba’s Tomb:")]), _vm._v(" Open all year round")]), _vm._v(" "), _c('p', [_vm._v("For "), _c('strong', [_vm._v("'HOW & WHEN TO MAKE RESERVATIONS' alone,")]), _vm._v(" please use the content as in the Trust website page "), _c('a', {
    attrs: {
      "href": _vm.website_page,
      "target": "_blank"
    }
  }, [_vm._v("Accommodation – Avatar Meher Baba Perpetual Public Charitable Trust (avatarmeherbabatrust.org).")])])])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-content', {
    attrs: {
      "ripple": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("How & When to Make Reservations")]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "grey lighten-3",
    staticStyle: {
      "max-height": "300px",
      "overflow-y": "auto"
    }
  }, [_c('p', [_vm._v("Reservations should be made by mail or email (email is faster and more convenient). Replies will be sent by mail or e-mail. Short-notice reservations can be requested by telephone but are not usually confirmed on the phone.")]), _vm._v(" "), _c('p', [_vm._v("Reservations should be made well in advance. Reservations for Meher Pilgrim Retreat are best made approximately six weeks before expected arrival. Please read the Pilgrim Season information above before continuing. Please scroll down for contact information.")]), _vm._v(" "), _c('p', [_vm._v("Please include the following information in all reservation requests:")]), _vm._v(" "), _c('p', [_vm._v("• Return address and telephone number."), _c('br'), _vm._v("\n                  • A few words of personal introduction, particularly for those who have not visited before."), _c('br'), _vm._v("\n                  • Names, dates of birth, and gender of those coming."), _c('br'), _vm._v("\n                  • Exact arrival date/time."), _c('br'), _vm._v("\n                  • Departure date/time from Meherabad."), _c('br'), _vm._v("\n                  • Nationality.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "151px",
      "width": "280px"
    },
    attrs: {
      "alt": "MPR",
      "src": "/static/doc-images/lists/htr1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Meher Pilgrim Retreat")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Reservations for Meher Pilgrim Retreat:     ")])]), _vm._v(" "), _c('p', [_vm._v("Email*:"), _c('a', {
    attrs: {
      "href": "mailto:pimco@ambppct.org"
    }
  }, [_vm._v("pimco@ambppct.org")]), _c('br'), _vm._v("\n                  Reservations: (0241) 254-8733"), _c('br'), _vm._v("\n                  From outside India:"), _c('br'), _vm._v("\n                  +91-241-254-8733")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "151px",
      "width": "280px"
    },
    attrs: {
      "alt": "",
      "src": "/static/doc-images/lists/htr2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Hostel \"D\"")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Reservations for Hostels or Dharmshala:  ")])]), _vm._v(" "), _c('p', [_vm._v("Email*:"), _c('a', {
    attrs: {
      "href": "mailto:jaibaba@ambppct.org"
    }
  }, [_vm._v("jaibaba@ambppct.org")]), _c('br'), _vm._v("\n                  phone: (+91) 241-2548777")])])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-content', {
    attrs: {
      "ripple": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Check-in Procedure")]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "grey lighten-3",
    staticStyle: {
      "max-height": "300px",
      "overflow-y": "auto"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_c('strong', [_vm._v("Indian Citizens")])]), _vm._v(" with prior reservations can check-in at Meher Pilgrim Retreat between the hours of 10:00 am and 7:00 pm only. Visitors with reservations at Hostel D or Dharmshala may check in between 9:00 am and 10:00 pm. Persons arriving after these designated hours will have to make their own accommodation arrangements for that night in Ahmednagar.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticStyle: {
      "text-decoration": "underline"
    }
  }, [_c('strong', [_vm._v("Non-Indians")])]), _vm._v(" are required to complete police registration at the Pilgrim Registration Office at the Meher Pilgrim Centre, lower Meherabad, before proceeding to Meher Pilgrim Retreat for check-in. Passport and two small photographs of each person are required. Hours for registration for those with confirmed reservations at Meherabad are 10:00 am to 6:00 pm.")])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19f29032","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/piligrim.vue
// module id = 299
// module chunks = 1